angular.module('qkr.session.expiry');



// WEBPACK FOOTER //
// ./src/sessionExpiry/config/session.expiry.config.js